module.exports = __webpack_public_path__ + "static/media/back.f0f84781.jpeg";